import { call, delay, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { filtrarEhOrdenar, setAttribute, setRelatorio, triggerChangeNome, triggerLoadDados, triggerTrocaFiltroRelatorio, triggerTrocaRelatorio,  } from "./EstoqueSlice";
import { formatDateJavaComHoras, formatDateSemHoras } from "../core/helpers";
import { server_url } from '../core/config_geral'
import axios from 'axios';

function* doLoadDados() {
    yield put(setAttribute({
        campo: "loading",
        valor: true
    }))

    var token = yield select((state) => state.auth.token)

    var payload = {
        "action" : "REL_DOWNLOAD_RELATORIO",
        "runNow" : true,
        "payload" : JSON.stringify({
            "codigo" : "REL_ANANO_DATA_GERENCIAMENTO_ESTOQUE",
            "tenantId" : "ae88fa77-75ac-4f2c-98ac-1d732fcbe07c",
            "versao" : "latest"
        })
    }

    var formData = new FormData()
    // formData.append("file",
    //     new Blob([JSON.stringify("")], {
    //         type: "application/json"
    //     }))
    formData.append("data",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.post(server_url + "/rpc", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))


    var data = r.data

    yield put(setAttribute({
        campo: "versao",
        valor: data.versao
    }))
    yield put(setAttribute({
        campo: "data",
        valor: formatDateSemHoras(data.data)
    }))
    yield put(setAttribute({
        campo: "desempenho",
        valor: data.desempenho
    }))

    yield put(setAttribute({
        campo: "distribuicao",
        valor: data.distribuicao
    }))

    yield put(setAttribute({
        campo: "produtos",
        valor: data.produtos
    }))

    yield put(setAttribute({
        campo: "fornecedores",
        valor: data.fornecedores
    }))

    yield put(triggerTrocaRelatorio({
        "codigo":"REL_CURVA_A",
    }))

    yield delay(100)

    yield put(setAttribute({
        campo: "loading",
        valor: false
    }))
}

function* doChangeNome(action) {
    
    var filtro = yield select(state => state.estoque.filtros)
    
    var nome = action.payload
    var novoFiltro = {
        ...filtro,
        nome
    }

    yield put(setAttribute({
        campo: "filtros",
        valor: novoFiltro
    }))
    yield put(filtrarEhOrdenar())
}

function* doChangeFiltroRelatorio(action) {

    console.log("Trocando filtro", action)
    
    var filtro = yield select(state => state.estoque.filtros)
    var novoFiltro = {...filtro}
    novoFiltro[action.payload.nome] = action.payload.value

    yield put(setAttribute({
        campo: "filtros",
        valor: novoFiltro
    }))

    yield put(filtrarEhOrdenar())
}

function* doTrocaRelatorio(action) {
    yield put(setRelatorio(action.payload))
    yield put(filtrarEhOrdenar())
    var filtros = yield select((state) => state.estoque.filtros)
}

export function* listenTriggerLoadDados() {
    yield takeEvery(triggerLoadDados, doLoadDados)
}

export function* listenTriggerChangeNome() {
    yield takeEvery(triggerChangeNome, doChangeNome)
}

export function* listenTrocaFiltroRelatorio() {
    yield takeEvery(triggerTrocaFiltroRelatorio, doChangeFiltroRelatorio)
}

export function* listenTriggerTrocaRelatorio() {
    yield takeEvery(triggerTrocaRelatorio, doTrocaRelatorio)
}